export default __webpack_public_path__ + "static/media/FuelPumpImg.1f0d3d2b.svg";